import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineSearch } from 'react-icons/hi';
import { VscClose } from 'react-icons/vsc';
import classNames from 'classnames';

import MInput from 'views/MInput/MInput';

import classes from './MSearchInput.module.scss';

type Props = {
  value?: string;
  inputRef: React.RefObject<HTMLInputElement>;
  placeholder?: string;
  alwaysOpen?: boolean;
  disabled?: boolean;
  className?: string;
  containerClassName?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearGeneralFilters?: () => void;
  onIconClick: () => void;
};

const MSearchInputView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(`${classes['container']} ${props.value ? classes['container--filled'] : ''} ${props.containerClassName}`)}>
      <MInput
        innerRef={props.inputRef}
        className={`${classes['container__inputWrapper']} ${
          props.value || props.alwaysOpen ? classes['container__inputWrapper--filled'] : ''
        } ${props.className}`.trim()}
        value={props.value}
        placeholder={props.placeholder || t('views.mServerTable.generalSearch')}
        disabled={props.disabled}
        onChange={props.onChange}
        startIcon={<HiOutlineSearch className={classes['searchIcon']} />}
        endIcon={props.value ? <VscClose onClick={props.onClearGeneralFilters} className={classes['btnClear']} /> : null}
        bottomBorder
        inputClassName={classes['input']}
      ></MInput>
    </div>
  );
};

MSearchInputView.displayName = 'MSearchInputView';
MSearchInputView.defaultProps = {};

export default MSearchInputView;
